import {
    Paper, Modal, Fade, Backdrop,
} from '@material-ui/core';
import { EmployeeReportType } from '../../Enums';
import EmployeePreferencesReport from './EmployeePreferencesReport';
import UnawardedShiftlinesReport from './UnawardedShiftlinesReport';
import EmployeeBiddingResultsReport from './EmployeeBiddingResultsReport';
import './EmployeeReport.scss';

/**
 * @typedef {{
 *  dataviewEmployeeData: ManagerAppData.IEmployee[],
 *  filteredDataviewEmployeeData: ManagerAppData.IEmployee[],
 *  dataviewFields: ManagerAppData.IDataviewFilter[],
 *  anchorDay: DayOfWeek,
 *  isRebid: boolean,
 *  showScheduledDateAndTime: boolean,
 *  dayCount: number
 *  isPeriodTypeDay: boolean
 *  onClose: Function,
 *  employeeFilters: {
 *   employeeId: number
 *   name: string
 *   rank: number
 *  }[]
 * }} ReportProps
 * @param {{
 *  profileId : string,
 *  employeeReport : EmployeeReport,
 *  sequentialSchedule: BidProfile.ISequentialEmployeeSchedule | null,
 *  lockedEmployeeIds: number[],
 * } & ReportProps} props
 */
const EmployeeReport = ({
    profileId,
    employeeReport,
    onClose,
    sequentialSchedule,
    lockedEmployeeIds,
    ...rest
}) => {
    const renderReport = () => {
        switch (employeeReport) {
            case EmployeeReportType.EmployeeChoices:
                return (
                    <EmployeePreferencesReport
                        profileId={profileId}
                        sequentialSchedule={sequentialSchedule}
                        onClose={onClose}
                        {...rest}
                    />
                );
            case EmployeeReportType.UnawardedShiftlines:
                return <UnawardedShiftlinesReport onClose={onClose} />;
            case EmployeeReportType.EmployeeRanks:
                return (
                    <EmployeeBiddingResultsReport
                        profileId={profileId}
                        showAwardedBid={false}
                        onClose={onClose}
                        {...rest}
                    />
                );
            case EmployeeReportType.EmployeeBiddingResults: {
                return (
                    <EmployeeBiddingResultsReport
                        profileId={profileId}
                        showAwardedBid
                        onClose={onClose}
                        {...rest}
                    />
                );
            }
            default:
                return null;
        }
    };
    return (
        <Modal
            open={employeeReport !== EmployeeReportType.None}
            onClose={onClose}
            className="report-modal"
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={employeeReport !== EmployeeReportType.None}>
                <Paper className="report-modal-paper">
                    {renderReport()}
                </Paper>
            </Fade>
        </Modal>
    );
};
export default EmployeeReport;
